import { useFormikContext } from 'formik';
import { get } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import { Keyboard } from 'react-native';
import { Input } from 'react-native-elements';
import styles from './styles';

const InputField = ({
  name,
  label,
  containerStyle,
  isPassword,
  returnKeyType,
  keyboardType,
  customLabelStyle,
  customInputStyle,
  placeholder,
  onSubmitEditing,
  disableAutoCapitalize,
  autoCompleteType,
  autoCorrect,
  customContainerStyle,
}: any) => {
  const { handleBlur, setFieldValue, touched, errors, values } =
    useFormikContext();
  const onChangeText = useCallback(
    (text) => {
      setFieldValue(name, text);
    },
    [name, setFieldValue],
  );

  const isTouched = useMemo(() => {
    return get(touched, name);
  }, [touched, name]);

  const value = useMemo(() => {
    return get(values, name);
  }, [values, name]);

  const error = useMemo(() => {
    return get(errors, name);
  }, [errors, name]);

  const onReturnKeyPress = useCallback(() => {
    Keyboard.dismiss();
    if (onSubmitEditing) {
      onSubmitEditing();
    }
  }, [onSubmitEditing]);

  return (
    <Input
      value={value}
      style={[styles.inputContainer]}
      label={label}
      onChangeText={onChangeText}
      secureTextEntry={isPassword}
      onBlur={() => handleBlur(name)}
      blurOnSubmit={false}
      underlineColorAndroid="transparent"
      renderErrorMessage={false}
      autoCapitalize={disableAutoCapitalize ? 'none' : 'sentences'}
      errorMessage={isTouched && error}
      returnKeyType={returnKeyType}
      labelStyle={[styles.labelStyle, customLabelStyle]}
      keyboardType={keyboardType || 'default'}
      containerStyle={containerStyle}
      inputStyle={customInputStyle}
      inputContainerStyle={[styles.inputContainerStyle, customContainerStyle]}
      placeholder={placeholder}
      onSubmitEditing={onReturnKeyPress}
      autoCompleteType={autoCompleteType}
      autoCorrect={autoCorrect}
    />
  );
};

export default InputField;
